import FullWidth from '@sportson/core-web/App/layouts/FullWidth';

import TableBlock, { type TableBlockProps } from 'libs/wordpress/content/Blocks/Table';

export interface TableModuleProps {
    data: {
        data: TableBlockProps['data'];
        moduleSettings: {
            displayFullWidthTable: boolean;
        };
    };
    layout: 'table';
}

const TableModule = ({ data }: TableModuleProps) => {
    const {
        data: blockData,
        moduleSettings: { displayFullWidthTable },
    } = data;

    return (
        <FullWidth gridColumn={displayFullWidthTable ? 'full-width' : 'standard'}>
            <TableBlock data={blockData} />
        </FullWidth>
    );
};

export default TableModule;
